// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import Header from '../../components/Header';
import MultiColumn from '../../components/MultiColumn';
import type { ColumnType } from '../../components/MultiColumn';
import DownloadBlock from './Internal/DownloadBlock';
import type { PropTypes as DownloadType } from './Internal/DownloadBlock';

type PropTypes = {|
  title: string,
  subtitle: string,
  intro: string,
  image: string,
  downloadContent: DownloadType,
  content?: {|
    title: string,
    items: Array<$Diff<ColumnType, { ctaText?: string, ctaHref?: string }>>,
  |},
|};

export default (props: PropTypes) => {
  return (
    <>
      <Header title={props.title} subtitle={props.subtitle} image={props.image}>
        {props.intro}
      </Header>
      <DownloadBlock {...props.downloadContent} className={styles.download} />
      {props.content && (
        <MultiColumn title={props.content.title} items={props.content.items} color />
      )}
    </>
  );
};
